<ta-json-root-node
  [canBeDeleted]="nested"
  [collapsed]="collapsed"
  [isLastChild]="isLastChild"
  [label]="rootName"
  [fieldType]="FieldType.Array"
  [animate]="animate"
  (clickDelete)="removeSelf.emit()"
  (clickAddChild)="toggleTopNewControlForm()"
  (clickToggleCollapsed)="toggleCollapsed()"
></ta-json-root-node>

<ta-json-new-child-form
  *ngIf="showNewControlForm"
  [parentType]="FieldType.Array"
  [existingKeys]="indices"
  (submit)="submitNewControlForm(0, $event)"
  (cancel)="showNewControlForm = false"
>
</ta-json-new-child-form>

<div
  [formGroup]="formGroup"
  [@growInOut]="collapsed ? 'collapsed' : 'open'"
  (mouseleave)="hoveredIdx = undefined"
>
  <ng-container formArrayName="array">
    <ng-container
      *ngFor="let control of formArray.controls; let i = index, let last = last"
    >
      <div
        (mouseenter)="hoveredIdx = i"
        class="ml--7 pt--2 position--relative"
        [ngClass]="{'border--left': !useLastChildStyling(i, last)}"
      >
        <ng-container [ngSwitch]="getFieldType(control.value)">
          <ta-json-object-editor
            *ngSwitchCase="FieldType.Object"
            [formControlName]="i"
            [isLastChild]="useLastChildStyling(i, last)"
            [animate]="animate"
            (removeSelf)="removeControl(i)"
            nested
          ></ta-json-object-editor>

          <ta-json-array-editor
            *ngSwitchCase="FieldType.Array"
            [formControlName]="i"
            [isLastChild]="useLastChildStyling(i, last)"
            [animate]="animate"
            (removeSelf)="removeControl(i)"
            nested
          ></ta-json-array-editor>

          <ta-json-value-editor
            *ngSwitchDefault
            [formControlName]="i"
            [isLastChild]="useLastChildStyling(i, last)"
            [animate]="animate"
            (delete)="removeControl(i)"
          ></ta-json-value-editor>
        </ng-container>

        <div
          *ngIf="hoveredIdx === i && activeNewControlFormIdx !== i"
          class="position--absolute"
          style="left: -6px; bottom: 0"
        >
          <button
            class="background--light pointer"
            taTooltipStatic="Add Child"
            aria-label="Add Child"
            (click)="openNewControlForm(i)"
          >
            <ta-icon icon="plus"></ta-icon>
          </button>
        </div>
      </div>

      <ta-json-new-child-form
        *ngIf="activeNewControlFormIdx === i"
        [parentType]="FieldType.Array"
        [existingKeys]="indices"
        [useLastChildStyling]="last"
        (submit)="submitNewControlForm(i + 1, $event)"
        (cancel)="activeNewControlFormIdx = undefined"
      >
      </ta-json-new-child-form>
    </ng-container>
  </ng-container>
</div>
